/* eslint-disable unicorn/filename-case */
export const initialState = {
  urls: {},
  nmisLogoutUrl: ''
}

export default (state = initialState) => state
